"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = get;
exports.post = post;
exports.postMultiple = postMultiple;
exports.put = put;
exports.deleteRequest = deleteRequest;
const InsightApiResponse_1 = require("./InsightApiResponse");
const axios_1 = require("axios");
const ApiErrors_1 = require("../errortypes/ApiErrors");
async function get(url, token) {
    const requestConfig = {};
    // If provided, add the token to the Authorization header
    if (token) {
        requestConfig.headers = {
            Authorization: token
        };
    }
    let apiRequest;
    try {
        apiRequest = await axios_1.default.get(url, requestConfig);
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    // Assign the response from the API to the InsightApiResponse class
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
async function post(url, body, token) {
    let apiRequest;
    try {
        apiRequest = await axios_1.default.post(url, body, configureRequest(token));
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
async function postMultiple(requests) {
    const responsesPromises = [];
    for (const request of requests) {
        responsesPromises.push(axios_1.default.post(request.url, request.body, configureRequest(request.token)));
    }
    const responses = await Promise.all(responsesPromises);
    const insightApiResponses = responses.map((r) => {
        throwIfError(r);
        return new InsightApiResponse_1.InsightApiResponse(r.data);
    });
    return insightApiResponses
        .map((d) => d.data)
        .reduce((acc, curr) => acc.concat(curr), []);
}
async function put(url, body, token) {
    let apiRequest;
    try {
        apiRequest = await axios_1.default.put(url, body, configureRequest(token));
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
// The reason of why `deleteRequest` was used instead of just `delete` is
// because it seems that `delete` is a reserved word and cannot be used
// to name this function.
async function deleteRequest(url, token) {
    let apiRequest;
    try {
        apiRequest = await axios_1.default.delete(url, configureRequest(token));
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
function configureRequest(token) {
    const requestConfig = {};
    if (token) {
        requestConfig.headers = {
            Authorization: token,
            'Content-Type': 'application/json;charset=UTF-8'
        };
    }
    else {
        requestConfig.headers = {
            'Content-Type': 'application/json;charset=UTF-8'
        };
    }
    return requestConfig;
}
function throwIfError(response) {
    if (response.data.ok) {
        return;
    }
    else {
        toErrorType(response.data.errorCode, response.data.errorMessage, response.data.canRetry);
    }
}
function tryThrowAsApiError(axiosError) {
    if (!axiosError.response.data) {
        throw new Error(axiosError.code);
    }
    else {
        toErrorType(axiosError.response.data.errorCode, axiosError.response.data.message);
    }
}
function toErrorType(errorCode, errorMessage, canRetry = false) {
    switch (errorCode) {
        case 'TOKEN_INVALID':
            throw new ApiErrors_1.TokenInvalidError(errorCode, errorMessage, canRetry);
        case 'TOKEN_EXPIRED':
            throw new ApiErrors_1.TokenExpiredError(errorCode, errorMessage, canRetry);
        case 'CONFLICT':
            throw new ApiErrors_1.ConflictError(errorCode, errorMessage, canRetry);
        default:
            throw new Error(errorCode);
    }
}
//# sourceMappingURL=api.js.map